function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCommentRecoveryX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m40 192 1.41-4.94a7.5 7.5 0 0 1-.549-1.657 8.664 8.664 0 0 1-.175-1.746 7.451 7.451 0 0 1 .6-2.984 7.7 7.7 0 0 1 4.073-4.073 7.721 7.721 0 0 1 5.968 0 7.7 7.7 0 0 1 4.073 4.073 7.721 7.721 0 0 1 0 5.968 7.7 7.7 0 0 1-4.073 4.073 7.45 7.45 0 0 1-2.984.6 8.664 8.664 0 0 1-1.746-.175 7.5 7.5 0 0 1-1.657-.549zm7.708-5.283h1.27v-2.375h2.387v-1.27h-2.387v-2.387h-1.27v2.387h-2.387v1.27h2.387z",
    transform: "translate(-40 -176)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCommentRecoveryX);
export default __webpack_public_path__ + "static/media/callCommentRecoveryX.d6667471e68ae6f661e99cad7a37f1ba.svg";
export { ForwardRef as ReactComponent };